import { render, staticRenderFns } from "./ViewUserView.vue?vue&type=template&id=19702f1b"
import script from "./ViewUserView.vue?vue&type=script&lang=js"
export * from "./ViewUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports